import apiClient from "../core/HttpClient";
import { EventOccasion } from "../models";

export default class EventOccasionService{
    url="/EventOccasions";

    public async getEventOccasions(): Promise<EventOccasion[]> {
        return await apiClient.get(this.url).then((res) => res.data);
    }

    public async getEventOccasionById(id: string): Promise<EventOccasion> {
        return await apiClient.get(`${this.url}/${id}`).then((res) => res.data);
    }

    public async createEventOccasion(eventOccasion: EventOccasion) {
        return await apiClient.post(this.url, eventOccasion);
    }

    public async updateEventOccasion(eventOccasion: EventOccasion) {
        return await apiClient.put(`${this.url}`, eventOccasion);
    }

    public async deleteEventOccasion(id: number) {
        return await apiClient.delete(`${this.url}/${id}`);
    }
    
}



